








































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ListModel } from "@/shared/models/listModel";
import { DataOptions } from "vuetify";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import * as _ from "lodash";
import { formatDateTimeAccordingToTimeZoneOrUTC } from "@/shared/dateFormatUtils";
import { Getter } from "vuex-class";
import { BusinessUnit } from "@/shared/models/businessUnit";

export interface PaymentGatewayTransactionLogItemModel {
  reservationId: number;
  paymentGateway: string;
  user: string;
  transactionKind: string;
  timeStamp: string;
  internalReference: string;
  isSuccess: boolean;
  description: string;
}

@Component
export default class PaymentGatewayTransactionLogModal extends Vue {
  @Getter("language/language") language?: string;
  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;

  @Prop({ default: "icon" }) buttonType?: "icon" | "button";
  @Prop({ default: 0 }) reservationId?: number;
  open = false;

  loading = false;

  headers = [
    {
      text: "Date",
      value: "timeStamp",
    },
    {
      text: "User",
      value: "user",
    },
    {
      text: "PaymentGatewayTransactionLog.TransactionKind",
      value: "transactionKind",
    },
    {
      text: "PaymentGatewayTransactionLog.InternalReference",
      value: "internalReference",
    },
    {
      text: "Amount",
      value: "amount",
    },
    {
      text: "PaymentGatewayTransactionLog.Description",
      value: "description",
    },
  ];

  get translatedHeaders() {
    return this.headers.map((x) => {
      return {
        ...x,
        text: this.$t(x.text),
      };
    });
  }

  list: ListModel<PaymentGatewayTransactionLogItemModel> = {
    count: 0,
    result: [],
  };

  debouncedLoad = _.debounce(this.load, 500);
  async load(): Promise<ListModel<PaymentGatewayTransactionLogItemModel>> {
    this.loading = true;
    return this.axios
      .get<ListModel<PaymentGatewayTransactionLogItemModel>>(
        "/reservations/GetPaymentGatewayTransactionLog",
        {
          params: this.queryParams,
        }
      )
      .then((res) => {
        //prettier-ignore
        this.list = res.data;

        return this.list;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["timeStamp"],
    sortDesc: [true],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!_.isEqual(fresh, old)) {
      this.load();
    }
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      reservationId: this.reservationId,
    };
  }

  @Watch("open")
  openWatch(fresh: boolean) {
    if (fresh) {
      this.load();
    } else {
      this.list.result = [];
      this.list.count = 0;
    }
  }

  formatTimezoneFromUtcToLocal(date: Date) {
    const unformatedTimeZone = this.activeBusinessUnit?.timeZoneId;
    const timeZone = unformatedTimeZone
      ? unformatedTimeZone.substring(0, unformatedTimeZone.indexOf(","))
      : undefined;

    return formatDateTimeAccordingToTimeZoneOrUTC(
      date,
      this.language ?? "",
      timeZone
    );
  }
}
